import Head from '@jetshop/core/components/Head';
import { ContentRenderer } from '../ContentRenderer';
import React from 'react';
function LegacyStartPage({ items, components, ProductGrid }) {
    if (!items || items.length < 1)
        return null;
    const numberOfRows = items[items.length - 1].row;
    return (React.createElement(React.Fragment, null, [...Array(numberOfRows)].map((_, index) => {
        const rowNumber = index + 1;
        const rowItems = items.filter((item) => item.row === rowNumber);
        if (rowItems[0]) {
            const firstItem = rowItems[0].item;
            if (rowItems.length > 0 && firstItem.content) {
                return rowItems.map(({ item }, itemIndex) => {
                    if (item.content) {
                        let content = null;
                        try {
                            content = JSON.parse(item.content);
                        }
                        catch (error) {
                            console.warn(`Unable to parse JSON content for ${item.name}`);
                        }
                        if (content) {
                            const Component = components[(content.componentName || item.name).toUpperCase()];
                            return Component ? (React.createElement(Component, Object.assign({ key: itemIndex }, content, { imageSrc: item.image &&
                                    item.image.url }))) : null;
                        }
                    }
                });
            }
            else if (firstItem.articleNumber) {
                const products = rowItems.map(({ item }) => item);
                return React.createElement(ProductGrid, { key: index, products: products });
            }
        }
        else
            return null;
    })));
}
const StartPageRenderer = ({ result, ProductGrid, startPageComponents: components, LoadingPage }) => {
    var _a, _b, _c;
    const data = result === null || result === void 0 ? void 0 : result.data;
    if (!(data === null || data === void 0 ? void 0 : data.startPage)) {
        return LoadingPage ? React.createElement(LoadingPage, null) : null;
    }
    const items = (_a = data.startPage.data) === null || _a === void 0 ? void 0 : _a.items;
    return (React.createElement(React.Fragment, null,
        React.createElement(Head, { data: data.startPage, route: (_b = data === null || data === void 0 ? void 0 : data.startPage) === null || _b === void 0 ? void 0 : _b.primaryRoute }),
        items && (items === null || items === void 0 ? void 0 : items.length) > 0 ? (React.createElement(ContentRenderer, { items: items, components: components })) : (React.createElement(LegacyStartPage, { items: (_c = data.startPage) === null || _c === void 0 ? void 0 : _c.items, components: components, ProductGrid: ProductGrid }))));
};
export default StartPageRenderer;
//# sourceMappingURL=StartPageRenderer.js.map